const modalContent = document.getElementById('property').querySelector('.property__content');
import { load } from '../../../utils/sections/registration';

let slug = '';

document.addEventListener('DOMContentLoaded', () => {
  const hash = location.hash.slice(1); // Remove the '#' from the hash
  if (hash) {
    const targetElement = document.querySelector(`[data-slug="${hash}"]`);
    targetElement && targetElement.click();
  }
});

window.addEventListener('modal:open', (event) => {
  if (event.target.id === 'property') {
    const t = event.detail.trigger;
    slug = t.dataset.slug;
    modalContent.innerHTML = t.querySelector('template').innerHTML;

    event.target.scrollTo(0, 0);
    slug && history.pushState(null, '', `#${slug}`);

    setTimeout(() => {
      load('gallery', modalContent.querySelector('[data-section-component="gallery"]'));
    }, 100);
  }
});

window.addEventListener('modal:close', (event) => {
  if (event.target.id === 'property') {
    slug && history.pushState(null, '', location.pathname);
  }
});
